export default __webpack_public_path__ + "assets/eritrea-flag.png";